import React, { RefObject } from 'react';
import { BRAND } from '../../../../constants/main';
import { StockModelCardOptionsStyledAC } from './AC/StockModelCardOptionsStyled.AC';
import { StockModelCardOptionsStyledAP } from './AP/StockModelCardOptionsStyled.AP';
import { StockModelCardOptionsStyledDS } from './DS/StockModelCardOptionsStyled.DS';
import { StockModelCardOptionsStyled } from './StockModelCardOptionsStyled';
import { SC } from '../../../../styles/theme';
import { BrandTypes } from '../../../../types/brands';
import { ISpecification } from '../../../../services/stock/models/stockItems.service.model';
import { TWithCollapsible } from '../../../hoc/withCollapsible';

export type StockModelCardOptionsProps = SC & {
    optionsList: string[];
    bodyStyle: ISpecification;
    id: string;
    withTooltip?: boolean;
    index: string | number;
    hasOptions?: boolean;
} & TWithCollapsible & {
        childRef?: RefObject<HTMLDivElement>;
    };

const StockModelCardOptions = (props: StockModelCardOptionsProps) => {
    if (BRAND === BrandTypes.AC) return <StockModelCardOptionsStyledAC {...props} />;
    if (BRAND === BrandTypes.AP) return <StockModelCardOptionsStyledAP {...props} />;
    if (BRAND === BrandTypes.DS) return <StockModelCardOptionsStyledDS {...props} />;
    return <StockModelCardOptionsStyled {...props} />;
};

export default StockModelCardOptions;
